export default {"src":"/_next/static/media/universityFill.2f063181.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};